import React from "react";
import ReactDOM from "react-dom";
import { ThemeProvider, Theme, StyledEngineProvider } from "@mui/material";
import App from "./App";

import * as serviceWorker from "./serviceWorker";
import { theme } from "./CommonUI/UITheme";
import "./index.css";


declare module '@mui/styles/defaultTheme' {
  // eslint-disable-next-line @typescript-eslint/no-empty-interface
  interface DefaultTheme extends Theme {}
}


export { default as ReactFromModule } from "react";

ReactDOM.render(
    <StyledEngineProvider injectFirst>
        <ThemeProvider theme={theme}>
            <App />
        </ThemeProvider>
    </StyledEngineProvider>,
    document.getElementById("root")
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
